import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { setCurrentNavPage } from "Actions";
import { fetchPublicPortal, login } from "Thunks";
import { getAuthInfosFromCookie } from "Utils";

import Subheader from "./Subheader";
import Infos from "./Infos";
import News from "./News";
import Team from "./Team";
import Docs from "./Docs";
import Contact from "./Contact";

//import { default as CommunityAdmin } from "./admin/Community";

class Home extends Component {
  componentDidMount() {
    const {
      navCommunity,
      push,
      setCurrentNavPage,
      fetchPublicPortal,
      login
    } = this.props;
    if (navCommunity && navCommunity.id) {
      push(`/community/${navCommunity.url}/${navCommunity.id}`);
    } else {
      const auth = getAuthInfosFromCookie();
      if (auth && auth.token) {
        login();
      }
      setCurrentNavPage("HOME_PAGE");
      fetchPublicPortal();
    }
  }

  componentDidUpdate(prevProps) {
    const { user, community, push } = this.props;

    if (!prevProps.community && community) {
      const auth = getAuthInfosFromCookie();
      if (auth && auth.id && user) {
        const navCom = user.communities.filter(
          com => community.id == com.id
        )[0];
        if (navCom) {
          push(`/community/${navCom.url}/${navCom.id}`);
        }
      }
    }
  }

  render() {
    const { community, user } = this.props;
    if (!community || user) {
      return <div id="portal-home" />;
    }
    return (
      <div id="portal-home">
        <Subheader community={community} />
        <Infos community={community} />
        <News community={community} />
        <Team community={community} />
        <Docs community={community} />
        <Contact community={community} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  navCommunity: state.auth.navCommunity,
  user: state.auth.user,
  community: state.params.publicPortal.community
});

const mapDispatchToProps = dispatch => ({
  push: url => dispatch(push(url)),
  setCurrentNavPage: navPage => dispatch(setCurrentNavPage(navPage)),
  fetchPublicPortal: () => dispatch(fetchPublicPortal()),
  login: () => dispatch(login())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/Home.js